import { create } from 'zustand'

/**
 * A page can name itself (e.g. "Cluster not found") without fighting
 * useTenantPageTitle for document.title: the page sets the override, the hook
 * (the single writer of document.title) composes it into the tab title (#301).
 */
interface PageTitleState {
  override: string | null
  setOverride: (title: string | null) => void
}

export const usePageTitleStore = create<PageTitleState>((set) => ({
  override: null,
  setOverride: (title) => set({ override: title }),
}))
